import React from 'react';
import { Menu } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { WAREHOUSE_ROUTES } from '../../../../constants/routes';
import { warehouseMenuItems, buildMenuItems, findMenuItem } from '../config/menuItems';

interface SidebarMenuProps {
  isMobile: boolean;
  onMobileClose: () => void;
}

export const SidebarMenu: React.FC<SidebarMenuProps> = ({ isMobile, onMobileClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const getSelectedKeys = () => {
    const path = location.pathname;

    if (path.includes('/inbound')) return ['inbound'];
    if (path.includes('/outbound')) return ['outbound'];
    if (path.includes(WAREHOUSE_ROUTES.warehouseProfile)) return ['profile'];
    return [];
  };

  const getOpenKeys = () => {
    const path = location.pathname;
    if (path.includes('/inbound') || path.includes('/outbound')) {
      return ['operations'];
    }
    return [];
  };

  const handleMenuClick = (menuInfo: any) => {
    const item = findMenuItem(warehouseMenuItems, menuInfo.key);
    if (item?.path) {
      navigate(item.path);
    }
  };

  const handleClick = (menuInfo: any) => {
    handleMenuClick(menuInfo);
    if (isMobile) {
      onMobileClose();
    }
  };

  return (
    <Menu
      mode="inline"
      selectedKeys={getSelectedKeys()}
      defaultOpenKeys={getOpenKeys()}
      items={buildMenuItems(warehouseMenuItems)}
      onClick={handleClick}
      className="warehouse-menu"
    />
  );
};
